// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__xWbBG","info":"Note_info__mpp7F","note":"Note_note__1Nmzy","actions":"Note_actions__Qygu9"};